import { useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { useDispatch } from 'react-redux';
import { CONNECTION_STATE_CHANGE } from 'aws-amplify/api';
import { Hub } from 'aws-amplify/utils';
import { toast } from 'react-toastify';

// graphql
import { gqlSubscribeFilteredJobService } from '../graphql/subscription/subscribeFilteredJobService';

// reducers
import { mutateJobSubscription } from '../stores/jobs';

// enum
import {
  ENUM_JOB_STATUS_TECH_ASSIG,
  ENUM_JOB_STATUS_JOB_INIT,
  ENUM_JOB_STATUS_JOB_NAV_CREATED,
  ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
  ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
} from '../utilities';

export const RealtimeJobsProvider = () => {
  // hooks
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const graphQLClient = generateClient();

      // listen for every job-status change
      const subscription = graphQLClient
        .graphql({
          query: gqlSubscribeFilteredJobService,
        })
        .subscribe({
          next: ({ data }) => {
            console.log(
              'providers.realtime.jobs@subscribeJobs#subscribe',
              'data',
              data,
            );

            const job = data.subscribeFilteredJobService;

            const interestedStatus = [
              ENUM_JOB_STATUS_TECH_ASSIG,
              ENUM_JOB_STATUS_JOB_INIT,
              ENUM_JOB_STATUS_JOB_NAV_CREATED,
              ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
              ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
              ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
              ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
            ];

            // update the job in Redux
            if (interestedStatus.includes(job.status)) {
              dispatch(mutateJobSubscription(job));
            }

            // notify the admin about a paid job
            if (job.status === ENUM_JOB_STATUS_TECH_ASSIG) {
              toast.success(
                'New job order is created and has been paid',
              );
            }
          },

          error: (error) => {
            console.warn(
              'providers.realtime.jobs@subscribeJobs#subscribe',
              error,
            );
          },
        });

      // monitor the subscription connection
      const stopListeningToHub = Hub.listen('api', (data) => {
        const { payload } = data;

        if (payload.event === CONNECTION_STATE_CHANGE) {
          const connectionState = payload.data.connectionState;

          console.log(
            'providers.realtime.jobs@subscribeJobs',
            connectionState,
          );
        }
      });

      // stop old listeners when component closes
      return () => {
        subscription.unsubscribe();
        stopListeningToHub();
      };
    } catch (error) {
      console.error(
        'providers.realtime.jobs@subscribeJobs',
        error,
      );
    }
  }, [dispatch]);

  return null;
};
